export default __webpack_public_path__ + "static/media/CartIcon.126c352f.svg";